export default __webpack_public_path__ + "static/media/massup_background_xl2.4bf26062.jpg";